"use client"

import React from "react"
import {
	Accordion,
	AccordionContent,
	AccordionItem,
	AccordionTrigger,
} from "@/components/ui/accordion"
import { Fade } from "@/components/ui/fade"

export interface FAQBlockBlock {
	title: string
	subtitle?: string | null
	faqs: {
		question: string
		answer: string
		id?: string | null
	}[]
	id?: string | null
	blockName?: string | null
	blockType: "faqBlock"
}

export const FAQBlockComponent: React.FC<FAQBlockBlock> = ({
	title,
	subtitle,
	faqs,
}) => {
	return (
		<section className="bg-white py-16 dark:bg-neutral-950">
			<div className="container mx-auto px-4">
				<Fade className="mb-12 text-center">
					<h2 className="mb-4 text-3xl font-bold text-black dark:text-white">
						{title}
					</h2>
					{subtitle && (
						<p className="mx-auto max-w-2xl text-lg text-gray-700 dark:text-gray-300">
							{subtitle}
						</p>
					)}
				</Fade>

				<Fade delay={200}>
					<div className="mx-auto max-w-3xl">
						<Accordion type="single" collapsible className="w-full">
							{faqs?.map((faq, index) => (
								<AccordionItem
									key={faq.id ?? index}
									value={`item-${index}`}
									className="mb-4 rounded-lg border border-gray-200 bg-white px-6 shadow-sm dark:border-neutral-800 dark:bg-neutral-900"
								>
									<AccordionTrigger className="text-left text-lg font-semibold text-black hover:no-underline dark:text-white">
										{faq.question}
									</AccordionTrigger>
									<AccordionContent className="text-base text-gray-600 dark:text-gray-400">
										{faq.answer}
									</AccordionContent>
								</AccordionItem>
							))}
						</Accordion>
					</div>
				</Fade>
			</div>
		</section>
	)
}
